import { FormattedMessage } from 'react-intl';
import { MoneyNoDecimals } from '../../../ui/moneyNoDecimals/MoneyNoDecimals';
import { VariableRate } from '../../../ui/rate/Rate';

import styles from './EstimatedRepayments.module.css';
import messages from './EstimatedRepayments.messages';
import TipBox from './components/TipBox';
import { GetMcaEstimatedScheduleResponse } from '@iwoca/lapi-client/edge';
import cn from 'classnames';

const EstimatedRepayments = ({
    schedule,
    className,
    loading
}: {
    schedule: GetMcaEstimatedScheduleResponse;
    className: string;
    loading: boolean;
}) => {
    return (
        <div className={className}>
            <div className={styles.estimatedRepaymentsTitle}>
                <FormattedMessage {...messages.estimatedRepaymentsTitle} />
            </div>

            <div className={styles.estimatedRepaymentsContent}>
                <div
                    data-testid="monthly-revenue"
                    className={styles.summaryRow}
                >
                    <div className={styles.estimatedRepaymentsColumn}>
                        <div>
                            <FormattedMessage
                                {...messages.currentMonthlyRevenue}
                            />
                        </div>
                        <div className={styles.averageRevnueCopy}>
                            <FormattedMessage
                                {...messages.monthlyRevenueExplanation}
                            />
                        </div>
                    </div>
                    <MoneyNoDecimals
                        className={cn(styles.summaryAmount, {
                            [styles.loading]: loading
                        })}
                        value={
                            schedule.data.estimated_schedule
                                .revenue_amount_per_month
                        }
                    />
                </div>

                <div
                    data-testid="estimated-repayment-amount"
                    className={styles.summaryRow}
                >
                    <span className={styles.estimatedRepaymentsLabel}>
                        <FormattedMessage
                            {...messages.estimatedRepayments}
                            values={{
                                percentage: (
                                    <span
                                        className={cn({
                                            [styles.loading]: loading
                                        })}
                                    >
                                        <VariableRate
                                            minimumFractionDigits={0}
                                            maximumFractionDigits={2}
                                            value={
                                                schedule.data.summary.sweep
                                                    .selected_sweep_fraction
                                            }
                                        />
                                    </span>
                                )
                            }}
                        />
                    </span>

                    <MoneyNoDecimals
                        className={cn(styles.summaryAmount, {
                            [styles.loading]: loading
                        })}
                        value={
                            schedule.data.estimated_schedule
                                .estimated_monthly_repayment_amount
                        }
                    />
                </div>

                <div
                    data-testid="months-to-repay"
                    className={styles.summaryRow}
                >
                    <FormattedMessage {...messages.timeToRepay} />{' '}
                    <span
                        className={cn(styles.summaryAmount, {
                            [styles.loading]: loading
                        })}
                    >
                        <FormattedMessage
                            {...messages.repaymentInMonths}
                            values={{
                                months: schedule.data.estimated_schedule
                                    .estimated_time_to_repay_in_months
                            }}
                        />
                    </span>
                </div>
            </div>

            <TipBox tip={<FormattedMessage {...messages.estimatedTipInfo} />} />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default EstimatedRepayments;
